import { createStore } from "redux"
import { composeWithDevTools } from "redux-devtools-extension"
import actions from "./actions"

const initialState = {
  language: "PL",
  showModal: false,
  modalContents: null,
  modalImage: null,
  modalTitle: null,
  modalAudio: null,
  modalAudioDescription: null,
  modalType: "horizontal",
  path: "/",
  hideSidebar: false,
  playerInstance: null,
  playerIsPlaying: false,
  avatarMessage: "",
  sliderTheme: null,
  closeModals: false,
}

function reducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_LANGUAGE:
      return { ...state, language: action.payload }
    case actions.SET_MODAL_CONTENTS:
      return { ...state, modalContents: action.payload }
    case actions.SET_MODAL_IMAGE:
      return { ...state, modalImage: action.payload }
    case actions.SET_SHOW_MODAL:
      return { ...state, showModal: action.payload }
    case actions.SET_MODAL_TYPE:
      return { ...state, modalType: action.payload }
    case actions.SET_MODAL_TITLE:
      return { ...state, modalTitle: action.payload }
    case actions.SET_MODAL_AUDIO:
      return { ...state, modalAudio: action.payload }
    case actions.SET_MODAL_AUDIODESCRIPTION:
      return { ...state, modalAudioDescription: action.payload }
    case actions.CLEAR_MODAL:
      return {
        ...state,
        modalType: initialState.modalType,
        modalImage: initialState.modalImage,
        modalContents: initialState.modalContents,
        modalTitle: initialState.modalTitle,
        modalAudio: initialState.modalAudio,
        modalAudioDescription: initialState.modalAudioDescription,
      }
    case actions.CLEAR_ARMY_MODAL:
      return {
        ...state,
        armyModalContents: initialState.armyModalContents,
      }
    case actions.SET_HIDE_SIDEBAR:
      return { ...state, hideSidebar: action.payload }
    case actions.SET_PATH:
      return { ...state, path: action.payload }
    case actions.TOGGLE_PLAYBACK:
      return { ...state, playerIsPlaying: !state.playerIsPlaying }
    case actions.SET_PLAYER_INSTANCE:
      return { ...state, playerInstance: action.payload }
    case actions.SET_AVATAR_MESSAGE:
      return { ...state, avatarMessage: action.payload }
    case actions.SET_SLIDER_THEME:
      return { ...state, sliderTheme: action.payload }
    case actions.CLOSE_MODALS:
      return { ...state, closeModals: action.payload }
    default:
      return state
  }
}

// preloadedState will be passed in by the plugin
export default preloadedState =>
  createStore(reducer, preloadedState, composeWithDevTools())
